import { http } from '@/libs/util';
import util from '@/libs/util'
const { 
    audit_customer_model_audit_models,
    audit_customer_model_save
 } = util.api || {}

 export function getListApi(params) {
    return http.get(audit_customer_model_audit_models, params)
}

// 
export function saveApi(params) {
    return http.post(audit_customer_model_save, params)
}